import errorAnimation from "../assets/animations/Animation - 1739976843865.json";
import Lottie from 'react-lottie-player';
import { useNavigate } from "react-router-dom";
import ROUTES from "@/config/routes";
import { useTranslation } from "react-i18next";
const PasswordExpiration = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    return (
        <div className="flex flex-col h-screen justify-between px-4 text-center border">
            {/* Centered Content */}
            <div className="flex flex-col items-center flex-grow justify-center gap-4">
                <Lottie 
                    animationData={errorAnimation} 
                    play 
                    speed={1} 
                    loop 
                    style={{ width: 200, height: 200 }} 
                />
                <h1 className="text-xl font-bold text-black leading-[100%]">
                    {t("v3.password_expiration.title", { defaultValue: "The password reset link has expired" })}
                </h1>
                <p className="text-black text-sm leading-[120%] whitespace-nowrap">
                    {t("v3.password_expiration.description", { defaultValue: "For security reasons, please return to the login page and request a new password reset." })}
                </p>
            </div>

            {/* Button Positioned Lower */}
            <div className="flex justify-center pb-10">
                <button onClick={() => navigate(ROUTES.login)} className="bg-white text-black border border-black px-6 py-3 rounded-lg font-semibold shadow-md hover:bg-gray-100 transition">
                {t("v3.btns.login_back", { defaultValue: "Back to login" })}
                </button>
            </div>
        </div>
    );
};
  export default PasswordExpiration;